import { IconButton } from "@blueprint/ui";
import { Loader } from "../../common/components/core";
import { useMemo, useState } from "react";
import InvoiceListFullList from "./components/InvoiceListFull";
import useFilterInvoiceListFullHandler, {
    FilterInvoiceListFullFormValues,
} from "./hooks/useInvoiceListFullFilterHandler";
import { useAllProjectList } from "../../api/project";
import { useContractorList } from "../../api/utilities";
import { usePaymentOrderApproverList } from "../../api/paymentOrder";
import { PageTitle } from "../../types/pageTitle";

const InvoiceListFullView = (): JSX.Element => {
    document.title = PageTitle.InvoiceListFullView;
    const [pageNo, setPageNo] = useState<number>(0);
    const pageSize = 10;

    const [filter, setFilter] = useState<FilterInvoiceListFullFormValues>({
        claimId: "",
        mainContractorName: "",
        invoiceId: "",
        externalBusinessId: "",
        projectId: "",
        dateFrom: null,
        dateTo: null,
    });

    const {
        data: PaymentOrderData,
        isValidating: isPaymentOrderDataValidating,
    } = usePaymentOrderApproverList(
        pageNo,
        pageSize,
        filter.claimId,
        filter.invoiceId,
        filter.mainContractorName,
        filter.externalBusinessId,
        filter.projectId,
        filter.dateFrom?.getTime(),
        filter.dateTo?.getTime(),
    );

    const { data: projectListData } = useAllProjectList();

    const { data: mainContractors } = useContractorList();

    const projectOptions = useMemo(() => {
        return projectListData?.map((it) => ({
            value: it.referenceId,
            label: it.name,
        }));
    }, [projectListData]);

    const mainContractorOptions = useMemo(() => {
        return mainContractors?.map(({ name, accountName }) => {

            return {
                label: name,
                value: accountName,
            };
        });
    }, [mainContractors]);

    const { show: showFilterHandler } = useFilterInvoiceListFullHandler(
        projectOptions ?? [],
        mainContractorOptions ?? [],
        filter,
        (values: FilterInvoiceListFullFormValues) => setFilter(values),
    );

    const nextPage = () => {
        if (PaymentOrderData && pageNo < Math.ceil(PaymentOrderData.total / PaymentOrderData.size)) {
            setPageNo(pageNo + 1);
        }
    };
    const previousPage = () => {
        if (pageNo > 0) {
            setPageNo(pageNo - 1);
        }
    };
    const toPage = (page: number) => {
        if (PaymentOrderData && page !== PaymentOrderData.page) {
            if (page >= 0 && page < PaymentOrderData.total) {
                setPageNo(page);
            }
        }
    };

    return (
        <>
            <div className="d-flex align-items-center mb-5">
                <h1 className="flex-grow-1 mb-0">Invoices</h1>
                <IconButton
                    icon="Filter"
                    variant="light.primary"
                    onClick={showFilterHandler}
                >
                    Filter
                </IconButton>
            </div>
            <Loader isLoading={isPaymentOrderDataValidating} overlay={true}>
                {
                    <InvoiceListFullList
                        paymentOrderList={PaymentOrderData}
                        nextPage={nextPage}
                        prevPage={previousPage}
                        toPage={toPage}
                    />
                }
            </Loader>
        </>
    );
};

export default InvoiceListFullView;
